import { render, staticRenderFns } from "./CaseFileUpload.vue?vue&type=template&id=92446f4c&scoped=true&"
import script from "./CaseFileUpload.vue?vue&type=script&lang=ts&"
export * from "./CaseFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFileUpload.vue?vue&type=style&index=0&id=92446f4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92446f4c",
  null
  
)

export default component.exports